import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="quiz-results center">
            <p class="mt2em">{{ 'feedback.Thank you! Your feedback has been saved.' | translate }}</p>
            <ul class="actions01 mt2em center">
                <li>
                    <a class="btn main" ng-if="vm.inFrame" ng-click="vm.closeModal()">{{ 'feedback.Close modal' | translate }}</a>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($window) {
        this.$window = $window;
        // check whether quiz is accessed via iframe
        this.inFrame = self !== top;
    }

    $onInit () {
        this.$window.scrollTo(0, 0);
    }

    closeModal () {
        if (this.inFrame) {
            parent.postMessage('closeQuiz()', '*');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/feedback/finished/index.js